module.exports = __webpack_public_path__ + "img/products-3.e52ef5f.webp";